import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatMobile',
  standalone: true
})
export class FormatMobilePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // si ya viene en formato E.164 (+521234567890)
    if (value.startsWith('+')) {
      const prefix = value.slice(0, value.length - 10); // ej: +52
      const digits = value.slice(-10); // ultimos 10

      if (digits.length !== 10) return value;

      const localFormatted = digits.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
      return `${prefix} ${localFormatted}`;
    }

    return value;
  }
}
